import { replacePlaceholder } from '@/common/converter/utils/replace-placeholder'
import { convertCellEvent } from '@/common/converter/convert-cell-event'
import { EVENT_TYPE } from '@/common/resources/const'
import { snakeToCamel } from '@/common/converter/utils/snake-to-camel'

/**
 * 찜 버튼 api 규격으로 변환
 * @param source
 * @param target
 * @returns {{buttontype: string, buttontitle: string, event_list: ({bodylist: *, url: string}|{})[], butonstate: string}}
 */
export const convertTopButtonList = (source = {}, target = {}) => {
  const { contextProperty = {}, eventList = [] } = source
  const topContext = contextProperty?.top
  const buttonState = snakeToCamel(topContext?.likeStatus) ?? ''
  const eventTypes = [EVENT_TYPE.ON_ZZIM, EVENT_TYPE.OFF_ZZIM]

  return {
    butonstate: replacePlaceholder(buttonState, target),
    buttontitle: '찜',
    buttontype: 'zzim',
    event_list: eventList
      ?.filter((event) => eventTypes.includes(event?.type))
      ?.map((event) => convertCellEvent(event, target)),
  }
}
